import React from 'react';
import PropTypes from 'prop-types';

const TaxonomyBadge = ({
	type,
	value,
}) => {
	const getTitle = () => {
		if (type === 'bundle') {
			return 'Bundles';
		}
		return 'APIs';
	};

	return (
		<div>
			<div
				className={`taxonomy-tree__badge is-${type}`}
				title={getTitle()}
			>
				{value}
			</div>
		</div>
	);
};

export default TaxonomyBadge;

TaxonomyBadge.propTypes = {
	type: PropTypes.string.isRequired,
	value: PropTypes.number.isRequired,
};
